import { Dispatch } from 'redux'
import getBrowserFingerprint from 'get-browser-fingerprint'
import { storeDispatchTypes } from "../../store/storeDispatchTypes"
import { apiAuth } from "../../api/apiInstance"

const getCodeSentResult = (gateway?: string) => gateway ? `Код отправлен через ${gateway}` : 'Код отправлен'

const getSmsCode = (phone: string) => async(
    dispatch: Dispatch,
): Promise<void> => {
    try {
        dispatch({
            type: storeDispatchTypes.setIsLoadingSms,
            value: {
                isLoading: true
            }
        })
        const { data: { status, msg, data } } = await apiAuth.post('/sendCode', {
            phone,
            deviceId: String(getBrowserFingerprint())
        })
        if(status === 'ok') {
            dispatch(({
                type: storeDispatchTypes.setCountDownResendSms,
                value: {
                    countDownResend: 45000
                }
            }))
            dispatch(({
                type: storeDispatchTypes.setCodeSentSms,
                value: {
                    isCodeSent: true
                }
            }))
            dispatch(({
                type: storeDispatchTypes.setCodeSentResultSms,
                value: {
                    msg: getCodeSentResult(data?.gateway)
                }
            }))
        }

    } catch (e) {
        console.error('sms code request failed', e)
    }
    dispatch({
        type: storeDispatchTypes.setIsLoadingSms,
        value: {
            isLoading: false
        }
    })
}

export default getSmsCode
